import React from "react";
import { useTheme } from "../../../../../hooks";
import { checkForActive } from "../../../../../utils";
import { getWindow } from "../../../../../utils/WindowUtil";
import { Icon } from "../../../../icon";
import CustomLink from "../../shared/link/CustomLink";
import { QuickLinkContainer } from "./QuickLinkStyles";
const QuickLink = ({ active, iconCategory, customLinkComponent, to = "", icon = "" }) => {
    const { Theme } = useTheme();
    const location = getWindow()?.location;
    const itemActive = active || (!!to ? checkForActive(location, to) : false);
    return (React.createElement(CustomLink, { to: to, customLinkComponent: customLinkComponent },
        React.createElement(QuickLinkContainer, { active: itemActive },
            React.createElement(Icon, { iconName: icon, iconCategory: iconCategory, styles: {
                    color: Theme.nav.mobile.nav.color,
                    hoverColor: Theme.nav.mobile.nav.color,
                } }))));
};
export default QuickLink;
//# sourceMappingURL=QuickLink.js.map